/** Shared loading, empty and failure states. The spec is explicit that no panel
 *  should ever render blank, so every async surface uses one of these. */

export function LoadingState({ label }: { label: string }) {
  return (
    <div
      role="status"
      className="mx-auto flex max-w-md flex-col items-center gap-3 px-6 py-24 text-center"
    >
      <span
        aria-hidden
        className="h-8 w-8 animate-spin rounded-full border-2 border-line-dim border-t-line"
      />
      <p className="text-sm text-ink-2">{label}</p>
    </div>
  );
}

export interface MessageStateProps {
  title: string;
  message: string;
  hint?: string;
  action?: { label: string; onClick: () => void };
  secondaryAction?: { label: string; onClick: () => void };
  tone?: "neutral" | "error";
}

export function MessageState({
  title,
  message,
  hint,
  action,
  secondaryAction,
  tone = "neutral",
}: MessageStateProps) {
  return (
    <div className="mx-auto max-w-xl px-6 py-24">
      <div className="corner-brackets border border-line-dim bg-black/40 p-6 text-center">
        <h2
          className={`label-caps text-lg font-semibold ${tone === "error" ? "text-level" : "text-ink"}`}
        >
          {title}
        </h2>
        <p className="mt-3 text-sm text-ink-2">{message}</p>
        {hint && (
          <p className="mt-3 border border-line-dim bg-black/40 px-3 py-2 text-left font-mono text-xs text-ink-3">
            {hint}
          </p>
        )}
        {(action || secondaryAction) && (
          <div className="mt-5 flex flex-wrap justify-center gap-3">
            {action && (
              <button
                type="button"
                onClick={action.onClick}
                className="label-caps border border-line bg-white/10 px-4 py-2 text-xs font-semibold transition-colors hover:bg-white/20"
              >
                {action.label}
              </button>
            )}
            {secondaryAction && (
              <button
                type="button"
                onClick={secondaryAction.onClick}
                className="label-caps border border-line-dim px-4 py-2 text-xs transition-colors hover:bg-white/10"
              >
                {secondaryAction.label}
              </button>
            )}
          </div>
        )}
      </div>
    </div>
  );
}
